import { memo, useMemo } from 'react';
import dashBoard from '../../assets/dashBoard.svg';
import hricon from '../../assets/hricon.svg';
import myAccount from '../../assets/myAccount.svg';
import approvals from '../../assets/approvals.svg';
import reportMenu from '../../assets/reportMenu.svg';
import products from '../../assets/products.svg';
import fileUploader from '../../assets/fileUploader.svg';
import buying from '../../assets/buying.svg';
import DefaultIcon from '../../assets/default.svg';
import operationsIcon from '../../assets/operation.svg';
import financeIcon from '../../assets/financeDetails.svg';
import purchaseIcon from '../../assets/purchaseDetails.svg';
import ActivationTool1 from '../../assets/ActivationTools 1.svg';
import AssessmentIcon from '@mui/icons-material/Assessment';
// import GroupIcon from "@mui/icons-material/Group";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ListAltIcon from '@mui/icons-material/ListAlt';
// import AppsIcon from "@mui/icons-material/Apps";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import LocalGroceryStoreSharpIcon from "@mui/icons-material/LocalGroceryStoreSharp";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
import DescriptionIcon from '@mui/icons-material/Description';
import HistoryIcon from '@mui/icons-material/History';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupsIcon from '@mui/icons-material/Groups';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import EngineeringIcon from '@mui/icons-material/Engineering';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import GppGoodIcon from '@mui/icons-material/GppGood';

interface IconRetrieveProps {
  icon: string;
  open: boolean;
}

const IconRetrieve = memo<IconRetrieveProps>(function IconRetrieve({
  icon,
  open,
}) {
  const arr = useMemo(
    () => [
      {
        name: 'IconDashboard',
        value: (
          <img
            src={dashBoard}
            alt="Dashboard Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      { name: 'Analatics', value: <AnalyticsIcon fontSize="small" /> },
      {
        name: 'IconReportAnalytics',
        value: <AssessmentIcon fontSize="small" />,
      },
      {
        name: 'IconCustomers',
        value: <GroupsIcon fontSize="small" />,
      },
      {
        name: 'IconVendors',
        value: <LocalShippingIcon fontSize="small" />,
      },
      {
        name: 'IconHR',
        value: (
          <img
            src={hricon}
            alt="HR Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      { name: 'IconList', value: <ListAltIcon fontSize="small" /> },
      // industry and governance modules (ERP menu blueprint)
      { name: 'IconRetail', value: <StorefrontIcon fontSize="small" /> },
      { name: 'IconTruck', value: <LocalShippingIcon fontSize="small" /> },
      { name: 'IconFactory', value: <PrecisionManufacturingIcon fontSize="small" /> },
      { name: 'IconProject', value: <EngineeringIcon fontSize="small" /> },
      { name: 'IconTools', value: <BuildCircleIcon fontSize="small" /> },
      { name: 'IconShield', value: <GppGoodIcon fontSize="small" /> },
      { name: 'IconReport', value: <DescriptionIcon fontSize="small" /> },
      {
        name: 'IconActivation',
        value: (
          <img
            src={ActivationTool1}
            alt="Activation Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },

      {
        name: 'IconProducts',
        value: (
          <img
            src={products}
            alt="product Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconApprovals',
        value: (
          <img
            src={approvals}
            alt="Approvals Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconMyAccount',
        value: (
          <img
            src={myAccount}
            alt="MyAccount Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconReportConfigurations',
        value: (
          <img
            src={reportMenu}
            alt="report Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        // M_MENU.MENU_ICON_NAME is VARCHAR2(20); this is the storable alias
        name: 'IconConfigurations',
        value: (
          <img
            src={reportMenu}
            alt="configuration Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconFileUpload',
        value: (
          <img
            src={fileUploader}
            alt="fileUploader Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconBuying',
        value: (
          <img
            src={buying}
            alt="Buying Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconFinanceDetails',
        value: (
          <img
            src={financeIcon}
            alt="Finance Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconPurchaseDetails',
        value: (
          <img
            src={purchaseIcon}
            alt="Purchase Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconOperations',
        value: (
          <img
            src={operationsIcon}
            alt="Operations Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconPayslip',
        value: (
          <img
            src={financeIcon}
            alt="Payslip Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconSalesOrder',
        value: (
          <img
            src={buying}
            alt="Payslip Icon"
            style={{
              width: '1.25rem',
              height: '1.25rem',
              opacity: open ? 1 : 0.5,
            }}
          />
        ),
      },
      {
        name: 'IconLog',
        value: <HistoryIcon fontSize="small" />,
      },
      {
        name: 'IconPayrollMgmt',
        value: <AccountBalanceWalletIcon fontSize="small" />,
      },
    ],
    [open]
  );

  const obj = useMemo(() => arr.find((o) => o.name === icon), [arr, icon]);

  return (
    <>
      {obj ? (
        obj.value
      ) : (
        <img
          src={DefaultIcon}
          alt="Default Icon"
          style={{
            width: '1.25rem',
            height: '1.25rem',
            opacity: open ? 1 : 0.5,
          }}
        />
      )}
    </>
  );
});

IconRetrieve.displayName = 'IconRetrieve';

export default IconRetrieve;
